import kamala from '../../kamala'
import Checkbox from './Checkbox'

Checkbox.install = function (Vue) {
  kamala(Vue)

  Vue.component(Checkbox.name, Checkbox)
}

export default Checkbox
